<template style="height: 100%;">
  <div class="indata">
    <ul>
      <li style="border-right: 1px solid rgb(219 219 219);">
        <h2>模板下载</h2>
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="选择模板">
            <el-select v-model="form.region" placeholder="请选择模板">
              <el-option label="模板一" value="shanghai"></el-option>
              <el-option label="模板二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span>选择模板:</span>
        <img :src="img1" alt="" />
        <el-button type="primary">下载模板</el-button>
      </li>

      <li>
        <h2>上传模板</h2>

        <el-form ref="form" :model="forms" label-width="80px">
          <el-form-item label="选择模板">
            <el-select v-model="form.regions" placeholder="请选择模板">
              <el-option label="模板一" value="shanghai"></el-option>
              <el-option label="模板二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span>选择模板:</span>
        <img :src="img2" alt="" />
        <el-button type="primary">下载模板</el-button>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      img1: require('../../assets/sgggg.png'),
      img2: require('../../assets/htd.png'),

      form: {
        region: '',
      },
      forms: {
        regions: '',
      },
    }
  },
  methods: {
    onSubmit() {},
  },
}
</script>
<style>
.indata {
  width: 99.8%;
  height: 100%;
  border: solid 1px #d5d5d5;
  min-height: 740px;
}
.indata ul {
  min-height: 740px;
  width: 100%;
}
.indata ul li {
  width: 49.8%;
  min-height: 340px;
  float: left;
  margin-top: 200px;
}
.indata ul li h2 {
  text-align: center;
}
.indata ul li .el-form {
  margin-top: 20px;
}
.indata ul li > span {
  margin-left: 180px;
  color: #606266;
}
.indata ul li img {
  margin-left: 8px;
}
.indata .el-form-item__label {
  margin-left: 170px;
}
</style>
